import { useMutation, useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useRecoilState } from "recoil";

import { GET_CLIP } from "MVVM/GraphQL/clip";
import { RESTORE_PRUNED_CLIP } from "MVVM/GraphQL/restorePrunedClip";
import { ViewableClip } from "MVVM/State/clip";

interface ClipExperienceViewModelProps {
  id: string;
}

const ClipExperienceViewModel = ({ id }: ClipExperienceViewModelProps) => {
  const {
    data: initialData,
    loading,
    error,
  } = useQuery(GET_CLIP, {
    variables: {
      id,
    },
    fetchPolicy: "network-only",
  });

  const [viewableClip, setViewableClip] = useRecoilState(ViewableClip);

  const [createPrunedClip] = useMutation(RESTORE_PRUNED_CLIP, {
    onError: () => {},
    refetchQueries: [GET_CLIP],
  });

  useEffect(() => {
    if (initialData?.clip) setViewableClip(initialData.clip);
  }, [initialData, setViewableClip]);

  const data = viewableClip ? { clip: viewableClip } : initialData;

  return {
    data,
    error,
    loading,
    createPrunedClip,
  };
};

export { ClipExperienceViewModel };
